<template>
    <div >
    <v-list height="500px" class="travel_options" v-if="trip !== undefined">
        <travel-option @click.native="showTravelOptionDetails(index)" class="pa-2 ma-2" v-for="(trip, index) in filtered_trip.tripPatterns" :travel_data=trip :key=index></travel-option>
    </v-list>
    
    </div>
</template>

<script>
import Vuetify from 'vuetify';
import gql from 'graphql-tag';
import TravelOption from './TravelOption.vue'

export default {
  components: {
      TravelOption,
  },
  properties: ["request"],
  apollo: {
    trip: {
      query: gql`query Trip($distance: Float!, $from_lat: Float!, $from_lng: Float!,
          $to_lat: Float!, $to_lng: Float!, $timestamp: DateTime!,) {
        trip(
          dateTime: $timestamp, 
          from: {coordinates: {latitude: $from_lat, longitude: $from_lng }},
          to: {coordinates: {latitude: $to_lat, longitude: $to_lng}},
          maximumWalkDistance: $distance
        ){
          tripPatterns {
            startTime
            endTime
            duration
            walkDistance
            legs {
              mode
              distance
              duration
              aimedEndTime
              aimedStartTime
              expectedEndTime
              expectedStartTime
              realtime
              ride
              line {
                id
                publicCode
                presentation {
                  textColour
                  colour
                }
              }
              fromPlace {
                name
                vertexType
              }
              toPlace {
                name
                vertexType
              }
              pointsOnLink{ 
                points
              }
              realtime
                serviceJourneyEstimatedCalls {
                destinationDisplay {
                  frontText
                }
              }
              
              
            }
          }
        }
      }`,
      variables () {
       return {
          distance: 2000, 
          from_lat: this.$attrs.request.start_location.latitude,
          from_lng: this.$attrs.request.start_location.longitude,
          to_lat: this.$attrs.request.end_location.latitude,
          to_lng: this.$attrs.request.end_location.longitude,
          timestamp: this.$attrs.request.timestamp,
       }
      },
      fetchPolicy: "no-cache",
      skip () {
        return this.$attrs.request == undefined
      },
    }

  },

  methods: {
    showTravelOptionDetails: function(index) {
      this.$emit('show-travel-option', this.filtered_trip.tripPatterns[index]);
    }
  },

  computed:{
    filtered_trip: function() {
      if (this.trip ) { ;
          console.log(this.trip);
          this.trip.tripPatterns = this.trip.tripPatterns.map(tripPattern => {
            tripPattern.legs = tripPattern.legs.filter(leg => {
              if (leg.mode == "foot" && leg.duration < 180) {
                return false;
              }
              return true;
            });
            return tripPattern;
        });
      }
      console.log(this.trip);
      return this.trip;
    }
  },

  data() {
    return {
      request: '',
    }
  },
};

</script>
<style scoped>
.travel_options::-webkit-scrollbar {
    width: 0.5em;
    height: 8px;
    background-color: whitesmoke;
}
.travel_options::-webkit-scrollbar-track {
  background-color: whitesmoke;
  width: 1em;
  border-width: 0;
}
.travel_options::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.travel_options {
  overflow-y: auto;
}

</style>